import React from 'react';
import imgImage40 from '../../assets/sections/85451ec1f1491a952558275f342cefa9e211a0a6.png';
import imgImage41 from '../../assets/sections/784dc449a1ca78333b88410cd9c3871f22de2979.png';
import imgImage42 from '../../assets/sections/37213501981147c36a4042e236d52e546b825e45.png';
import imgImage39 from '../../assets/sections/a161c0f4ed7e5b49df24bb342843a41a9ae34f55.svg';


export default function ContactQR() {
  return (
    <div className="relative w-[1920px] h-[597px]" data-node-id="223:154">
      <div className="absolute bg-[#002e2a] h-[598px] left-0 pointer-events-none top-[-1px] w-[1920px]" data-name="image 7" data-node-id="223:155" />
      <div className="absolute contents left-0 top-[-1px]" data-node-id="226:257">
        <div
          className="absolute h-[596px] left-0 pointer-events-none top-0 w-[1920px]"
          data-name="image 39"
          data-node-id="226:363"
          style={{ maskImage: `url('${imgImage39}')`, WebkitMaskImage: `url('${imgImage39}')`, maskRepeat: 'no-repeat', WebkitMaskRepeat: 'no-repeat', maskPosition: '0px -1px', WebkitMaskPosition: '0px -1px', maskSize: '1920px 598px', WebkitMaskSize: '1920px 598px' }}>
          <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgImage40} />
        </div>
      </div>
      <div className="-translate-x-1/2 absolute content-stretch flex gap-[265px] items-start left-1/2 top-[89px]" data-node-id="226:403">
        <div className="content-stretch flex flex-col gap-[24px] items-center relative shrink-0 w-[511px]" data-node-id="226:396">
          <div className="content-stretch flex flex-col gap-[12px] items-center justify-center relative shrink-0 w-full" data-node-id="226:220">
            <p className="font-['Alexandria',sans-serif] font-medium leading-[normal] relative shrink-0 text-[#e3fff1] text-[33px] text-shadow-[0px_5px_14.8px_rgba(255,255,255,0.25)] uppercase whitespace-nowrap" data-node-id="226:222">
              Zalo Group
            </p>
            <p className="font-['Alexandria',sans-serif] font-light leading-[28px] opacity-60 relative shrink-0 text-[#e9fffa] text-[20px] text-center w-[511px]" data-node-id="226:230">
              Tham gia ngay để không bỏ lỡ thông tin chi tiết về chuỗi hoạt động của TopCV tại Hải Phòng
            </p>
          </div>
          <div className="content-stretch flex flex-col items-start overflow-clip p-[12px] relative rounded-[12px] shadow-[0px_37px_32.8px_0px_rgba(0,177,79,0.1)] shrink-0" data-name="Background+Shadow" data-node-id="226:381">
            <div aria-hidden="true" className="absolute bg-[rgba(0,46,42,0.1)] inset-0 pointer-events-none rounded-[12px]" />
            <div className="h-[250px] relative rounded-[10px] shrink-0 w-[250px]" data-name="image 41" data-node-id="226:384">
              <div className="absolute inset-0 overflow-hidden pointer-events-none rounded-[10px]">
                <img alt="" className="absolute h-full left-[-3.61%] max-w-none top-[-0.12%] w-[103.48%]" src={imgImage41} />
              </div>
            </div>
            <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_14px_10px_222px_0px_rgba(0,177,79,0.2)]" />
          </div>
          <a
            href="https://zalo.me/4375535862287538711?src=qr"
            target="_blank"
            rel="noreferrer"
            className="cursor-pointer bg-[#01b150] content-stretch flex items-center justify-center px-[24px] py-[16px] relative rounded-[8px] shadow-[0px_24px_84px_0px_rgba(0,255,114,0.3)] shrink-0 no-underline"
            data-name="Discount container"
            data-node-id="226:393"
          >
            <p className="font-['Alexandria',sans-serif] font-bold leading-[1.5] relative shrink-0 text-[18px] text-center text-white whitespace-nowrap" data-node-id="226:394">
              KHÁM PHÁ NGAY
            </p>
          </a>
        </div>
        <div className="content-stretch flex flex-col gap-[24px] items-center relative shrink-0 w-[680px]" data-node-id="226:397">
          <div className="content-stretch flex flex-col gap-[12px] items-center justify-center relative shrink-0 text-center w-full" data-node-id="226:365">
            <p className="font-['Alexandria',sans-serif] font-medium leading-[normal] relative shrink-0 text-[#e3fff1] text-[33px] text-shadow-[0px_5px_14.8px_rgba(255,255,255,0.25)] uppercase whitespace-nowrap" data-node-id="226:366">
              Các vị trí tuyển dụng tại Hải Phòng
            </p>
            <p className="font-['Alexandria',sans-serif] font-light leading-[28px] opacity-60 relative shrink-0 text-[#e9fffa] text-[20px] w-[420px]" data-node-id="226:367">
              Quét QR để xem ngay các vị trí ở Hải Phòng phù hợp với bạn
            </p>
          </div>
          <div className="content-stretch flex flex-col items-start overflow-clip p-[12px] relative rounded-[12px] shadow-[0px_37px_32.8px_0px_rgba(0,177,79,0.1)] shrink-0" data-name="Background+Shadow" data-node-id="226:373">
            <div aria-hidden="true" className="absolute bg-[rgba(0,46,42,0.1)] inset-0 pointer-events-none rounded-[12px]" />
            <div className="relative shrink-0 size-[250px]" data-name="image 40" data-node-id="226:379">
              <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgImage42} />
            </div>
            <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_14px_10px_222px_0px_rgba(0,177,79,0.2)]" />
          </div>
          <div className="cursor-pointer bg-[#01b150] content-stretch flex items-center justify-center px-[24px] py-[16px] relative rounded-[8px] shadow-[0px_24px_84px_0px_rgba(0,255,114,0.3)] shrink-0" data-name="Discount container" data-node-id="226:398"
            onClick={() => {
              window.open("https://q.me-qr.com/amcq8b6r", "_blank")
            }}
          >
            <p className="font-['Alexandria',sans-serif] font-bold leading-[1.5] relative shrink-0 text-[18px] text-center text-white whitespace-nowrap" data-node-id="226:399">
              KHÁM PHÁ NGAY
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
